<template>
  <div class="refresh">
    <label class="auto">
      <input type="checkbox" v-model="auto" />
      Actualisation automatique ({{ seconds }} s)
    </label>
    <span v-if="updatedAt" class="updated">Mis à jour à {{ time(updatedAt) }}</span>
    <div class="refresh-button">
      <CustomButton :params="{text: 'Actualiser'}" :isSecondary="true" :isCompact="true" @click="callback" />
    </div>
  </div>
</template>

<script>
import CustomButton from "@/components/forms/customs/customButton/CustomButton.vue";
import {time} from "@/administration/utils";

/**
 * Actualise une page à intervalle régulier (tant que l'onglet est affiché) ou à la demande.
 * callback : recharge les données ; updatedAt : date de la dernière actualisation.
 */
export default {
  name: 'AutoRefresh',
  components: {CustomButton},
  props: {
    callback: {type: Function, required: true},
    updatedAt: {type: String, default: ''},
    seconds: {type: Number, default: 30},
  },
  data() {
    return {auto: true, timer: undefined};
  },
  mounted() {
    this.timer = setInterval(() => {
      if (this.auto && !document.hidden) this.callback();
    }, this.seconds * 1000);
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
  methods: {time},
};
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

.refresh
  display flex
  flex-wrap wrap
  align-items center
  justify-content flex-end
  gap 8px 16px
  margin-bottom 14px
  font-size 13px
  color CTRL_TEXT_MUTED

.auto
  display flex
  align-items center
  gap 6px
  cursor pointer

  input
    accent-color THEME_COLOR_PRIMARY

.refresh-button
  width 120px
</style>
